import { AppState as AuthAppState, LogoutOptions, RedirectLoginOptions } from '@auth0/auth0-react';
import { AnyAction, Dispatch } from 'redux';
import { AppState } from '../../../store/store';
import { ThunkResult } from '../shared/ThunkResult';

export const logoutAsHealer = (
  logout: (options?: LogoutOptions) => Promise<void>,
  loginWithRedirect: (options?: RedirectLoginOptions<AuthAppState>) => Promise<void>
): ThunkResult<void> => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    logout({ logoutParams: { returnTo: window.location.origin } }).then(() => {
      dispatch({ type: 'HEALER_LOGGED_OUT' });
    });
  };
};
